const DISABLED_OPACITY = 0.4;

const BASE_BUTTON_STYLING = {
  h: "button",
  minW: "button",
  px: "16px",
  fontWeight: "600",
  rounded: 0,
  overflow: "hidden",
};

export const BUTTON_STYLES = {
  baseStyle: BASE_BUTTON_STYLING,
  variants: {
    primary: {
      ...BASE_BUTTON_STYLING,
      bg: "brand.primary",
      color: "gray.100",
      borderColor: "brand.primary",

      _hover: {
        bg: "brand.primary_hover",
        _disabled: {
          opacity: DISABLED_OPACITY,
          color: "gray.300",
          bg: "gray.500",
          borderColor: "gray.500",
        },
      },
      _disabled: {
        opacity: DISABLED_OPACITY,
        color: "gray.300",
        bg: "gray.500",
        borderColor: "gray.500",
      },
    },
    secondary: {
      ...BASE_BUTTON_STYLING,
      bg: "brand.secondary",
      color: "brand.primary",

      _hover: {
        bg: "brand.secondary_hover",
        _disabled: {
          opacity: DISABLED_OPACITY,
          color: "gray.300",
          bg: "gray.500",
          borderColor: "gray.500",
        },
      },
      _disabled: {
        opacity: DISABLED_OPACITY,
        color: "gray.300",
        bg: "gray.500",
        borderColor: "gray.500",
      },
    },
    danger: {
      ...BASE_BUTTON_STYLING,
      bg: "red.400",
      color: "gray.100",
      borderWidth: "2px",

      borderColor: "red.400",
      _hover: {
        bg: "linear-gradient(0deg, rgba(44, 59, 69, 0.10) 0%, rgba(44, 59, 69, 0.10) 100%), #E94E3D",
        _disabled: {
          opacity: DISABLED_OPACITY,
          color: "gray.300",
          bg: "gray.500",
          borderColor: "gray.500",
        },
      },
      _disabled: {
        opacity: DISABLED_OPACITY,
        color: "gray.300",
        bg: "gray.500",
        borderColor: "gray.500",
      },
    },
  },
};
